import { render, staticRenderFns } from "./IdentityTheftReportAddButton.vue?vue&type=template&id=44030c4c&"
import script from "./IdentityTheftReportAddButton.vue?vue&type=script&lang=js&"
export * from "./IdentityTheftReportAddButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports